import { App } from '@openedx/frontend-base';
import { addScript, addSlot } from './utils';
// Chrome the site's `customApp` puts in slots through FRONTEND_SLOTS.
//
// `dist-fb`, not `dist`: the forks ship two builds from one source, and the classic one still imports
// `@edx/frontend-platform`, which this site does not have. A deep path because neither declares an
// `exports` map - adding one would break the deep imports classic MFEs rely on.
import {
  emptyShellAnonymousMenu,
  emptyShellAuthenticatedMenu,
  emptyShellMobileAnonymousMenu,
  emptyShellMobileAuthenticatedMenu,
  emptyShellSecondaryLinks,
  headerSlotOperation,
} from '@edx/frontend-component-header/dist-fb/frontend-base';
import { footerSlotOperation } from '@edx/frontend-component-footer/dist-fb/frontend-base';

const customApp: App = {
  appId: 'custom',
};
addSlot(customApp, headerSlotOperation);
addSlot(customApp, footerSlotOperation);
addSlot(customApp, emptyShellSecondaryLinks);
addSlot(customApp, emptyShellAuthenticatedMenu);
addSlot(customApp, emptyShellAnonymousMenu);
addSlot(customApp, emptyShellMobileAuthenticatedMenu);
addSlot(customApp, emptyShellMobileAnonymousMenu);

export default customApp;